import { Icon, IconName, Text } from "@zapier/design-system";

import styles from "./DefaultAppTileButton.module.css";

type Props = {
  isDisabled?: boolean;
  onClick: () => void;
  title: string;
  subtitle: string;
  iconName: IconName;
};

export function DefaultAppTileButton({
  isDisabled = false,
  onClick,
  title,
  subtitle,
  iconName,
}: Props) {
  const textColor = isDisabled ? "GrayWarm5" : undefined;
  const iconColor = isDisabled ? "GrayWarm5" : "BrandOrange";

  return (
    <button className={styles.tile} disabled={isDisabled} onClick={onClick}>
      <div className={styles.buttonContent}>
        <Icon name={iconName} color={iconColor} size={24} />
        <Text type="ParagraphHeader3" color={textColor}>
          {title}
        </Text>
        <Icon name="formAdd" color="currentColor" size={24} />
      </div>
      <Text type="SmallPrint1" color={textColor}>
        {subtitle}
      </Text>
    </button>
  );
}
